import request from '@/utils/request'

export function fetchClassesList(params) {
  return request({
    url:'/classes/list',
    method:'get',
    params:params
  })
}



// WEBPACK FOOTER //
// ./src/api/classes.js